import React, { useState } from "react";
import { subscribeNewsletter } from "../lib/api";
import { analytics } from "../lib/analytics";
import { toast } from "sonner";

export const NewsletterInline = ({ tone = "olive", testid = "newsletter" }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const cream = tone === "cream";
  const inputStyle = cream
    ? { backgroundColor: "transparent", color: "var(--cream)", borderColor: "rgba(245,242,238,0.4)" }
    : { backgroundColor: "transparent", color: "var(--olive)", borderColor: "rgba(79,87,70,0.4)" };
  const btnClass = cream ? "" : "";
  const btnStyle = cream
    ? { backgroundColor: "var(--cream)", color: "var(--olive)", borderColor: "var(--cream)" }
    : { backgroundColor: "var(--olive)", color: "var(--cream)", borderColor: "var(--olive)" };

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await subscribeNewsletter(email, tone === "cream" ? "footer" : "inline");
      setDone(true);
      if (!res.already_subscribed) analytics.newsletterSignup(tone === "cream" ? "footer" : "inline");
      toast.success(res.already_subscribed ? "You're already on the list — thank you." : "Welcome. Check your inbox.");
      setEmail("");
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="font-serif-editorial text-xl" style={{ color: cream ? "var(--cream)" : "var(--olive)" }} data-testid={`${testid}-done`}>
        Welcome to the correspondence.
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3" data-testid={`${testid}-form`}>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Your email address"
        required
        data-testid={`${testid}-email-input`}
        className="flex-1 px-4 py-3 border text-sm outline-none placeholder:opacity-60"
        style={inputStyle}
      />
      <button
        type="submit"
        disabled={loading}
        data-testid={`${testid}-submit`}
        className={`px-6 py-3 text-xs uppercase wide-track border ${btnClass}`}
        style={btnStyle}
      >
        {loading ? "…" : "Subscribe"}
      </button>
    </form>
  );
};

export default NewsletterInline;
